// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6U6jH","rounded":"styles_rounded__2i_nV"};